import angular from 'angular';

/* Controller Imports */
import CreatePlanController from './create/create.controller';
import MaintenancePlansController from './plans.controller';
import MaintenancePlansDeleteModalController from './details/delete/delete.controller';
import MaintenancePlansDetailsController from './details/details.controller';
import MaintenancePlansDetailsTasksController from './details/tasks/tasks.controller';
/* Directive Imports */
import PlanFormScheduleDirective from './create/schedule/schedule.directive';
import PlanFormTasksDirective from './create/tasks/tasks.directive';
/* Named/Mix Imports */
import {
  PlanAssetDeleteModalController,
  PlanFormAssetsController,
  PlanFormAssetsDirective
} from './create/assets/assets.directive';

import FormMaintenanceDirective from './create/form/form.directive';

const planModule = angular
  .module('app.maintenance.plans', ['ui.bootstrap', 'ui.router', 'gettext'])
  .controller('CreatePlanController', CreatePlanController)
  .controller('MaintenancePlansController', MaintenancePlansController)
  .controller('MaintenancePlansDeleteModalController', MaintenancePlansDeleteModalController)
  .controller('MaintenancePlansDetailsController', MaintenancePlansDetailsController)
  .controller('MaintenancePlansDetailsTasksController', MaintenancePlansDetailsTasksController)
  .controller('PlanAssetDeleteModalController', PlanAssetDeleteModalController)
  .controller('PlanFormAssetsController', PlanFormAssetsController)
  /* Directives */
  .directive('planFormAssets', PlanFormAssetsDirective)
  .directive('planFormSchedule', PlanFormScheduleDirective)
  .directive('planFormTasks', PlanFormTasksDirective)
  .directive('formMaintenance', FormMaintenanceDirective);

export default planModule.name;
